import axios from 'axios'
export default {
  props: {
    uploadUrl: {
      type: String,
      required: false,
      default: null
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    gallery: {
      type: String,
      required: false,
      default: 'global'
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    fileTypes: {
      type: Array,
      required: false,
      default: () => null
    },
    allowPasteImageUpload: {
      type: Boolean,
      default: false
    },
    imagesOnly: {
      type: Boolean,
      default:false
    },
    postFields: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    postUrlComputed () {
      if (this.uploadUrl) {
        return this.uploadUrl
      } else {
        return '/api/v1/upload'
      }
    },
    uid () {
      return this._uid
    },
    accept () {
      if(this.imagesOnly) {
        return ['image/jpeg', 'image/png','image/webp'].join(',')
      }
      if (this.fileTypes && Array.isArray(this.fileTypes) && this.fileTypes.length > 0) {
        return this.fileTypes.join(',')
      } else {
        return null
      }
    }
  },
  data () {
    return {
      UploadError: null,
      LoadingUploading: false,
      ShowPasteField: false,
      CancelTokenSource: null,
      UploadPercentage: 0,
      FormDataObject: null
    }
  },
  emits: ['uploaded', 'uploadedImage','input','update:modelValue'],
  methods: {
    cancelUpload () {
      this.CancelTokenSource.cancel('Upload cancelled')
    },
    buildFormData() {
      const formDataObject = new FormData()
      for(const key in this.postFields) {
        formDataObject.append(key, this.postFields[key])
      }
      return formDataObject
    },
    async syncFile () {
      try {
        this.UploadError = null
        const files = this.$refs.uploadableField.files
        const formDataObject = this.buildFormData()
        formDataObject.append('multiple', this.multiple)
        if (this.multiple) {
          for (let i = 0; i < files.length; i++) {
            formDataObject.append('files[' + i + ']', files[i])
          }
        } else {
          formDataObject.append('file', files[0])
        }
        if (this.gallery) {
          formDataObject.append('available_in_gallery', this.gallery)
        }
        this.LoadingUploading = true
        this.CancelTokenSource = axios.CancelToken.source()
        // await axios.get('/sanctum/csrf-cookie')
        let _this = this
        const response = await axios.post(this.postUrlComputed, formDataObject, {
          headers: { 'Content-Type': 'multipart/form-data' },
          cancelToken: this.CancelTokenSource.token,
          onUploadProgress: function (progressEvent) {
            _this.UploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
          }
        })
        const data = response.data
        const input = this.$refs.uploadableField
        input.type = 'text'
        input.type = 'file'
        this.UploadPercentage = 0

        this.$emit('input', data)
        this.$emit('uploaded', data)
        this.$emit('update:modelValue', data)

        this.LoadingUploading = false
      } catch (e) {
        console.error(e)
        if(e.response) {
          console.log(e, e.response.response, e.response.response.data)
          this.UploadError = e.response.response.data.message
        }
        const input = this.$refs.uploadableField
        input.type = 'text'
        input.type = 'file'
        this.CancelTokenSource = null
        this.UploadPercentage = 0
        this.LoadingUploading = false
        this.$notify(this.UploadError, 'danger')
      }
    }
  }
}
